/* Shared design tokens for PSI UI components.
   Import this file in any component that needs these tokens. */

:root {
    /* Motion: spring easing curves */
    --spring-1: linear(0, 0.012 0.9%, 0.05 2%, 0.411 9.2%, 0.517 11.8%, 0.611 14.6%, 0.694 17.7%, 0.765 21.1%, 0.824 24.8%, 0.872 28.9%, 0.91 33.4%, 0.939 38.4%, 0.977 50.9%, 0.994 68.4%, 1);

    /* Exposed as var() aliases so .module.css files can reference the global
       @keyframes without lightningcss hashing the animation name. */
    --animation-slide-in: slideIn;
    --animation-slide-out: slideOut;
    --animation-slide-delay: 500ms;
    --animation-offset-default: 4px;
    --animation-progress-circle-spin: progressCircleSpin;
}

/* React Aria placement → slide direction mapping.
   data-placement is set by React Aria on all overlay elements (popovers, tooltips, menus).
   --slide-x/--slide-y are consumed by slideIn/slideOut animations. */
[data-placement='top']    { --slide-y:  var(--animation-offset-default); }
[data-placement='right']  { --slide-x: calc(var(--animation-offset-default) * -1); }
[data-placement='bottom'] { --slide-y: calc(var(--animation-offset-default) * -1); }
[data-placement='left']   { --slide-x:  var(--animation-offset-default); }

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(var(--slide-x, 0)) translateY(var(--slide-y, 0));
    }
}

@keyframes slideOut {
    to {
        opacity: 0;
        transform: translateX(var(--slide-x, 0)) translateY(var(--slide-y, 0));
    }
}

@keyframes progressCircleSpin {
    to { transform: rotate(360deg); }
}
